var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRivalAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 386 386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 193,
    r: 193,
    fill: "#25282d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.32,235.71c7.23,9.8,23.37,16.5,41.35,16.27,17.33-.24,32.5-6.84,39.45-16.27",
    fill: "none",
    stroke: "#d1f434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.37,179.78c0,8.75-7.09,15.84-15.84,15.84s-15.84-7.09-15.84-15.84,7.09-15.84,15.84-15.84,15.84,7.09,15.84,15.84Z",
    fill: "none",
    stroke: "#d1f434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.91,
    cy: 179.78,
    r: 15.84,
    fill: "none",
    stroke: "#d1f434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.8,
    y1: 92.64,
    x2: 231.09,
    y2: 123.86,
    fill: "none",
    stroke: "#d1f434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.24,
    cy: 86.22,
    r: 9.08,
    fill: "none",
    stroke: "#d1f434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.35,
    y1: 123.86,
    x2: 130.65,
    y2: 92.64,
    fill: "none",
    stroke: "#d1f434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.2,
    cy: 86.22,
    r: 9.08,
    fill: "none",
    stroke: "#d1f434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.44,
    y1: 205.58,
    x2: 303.43,
    y2: 205.58,
    fill: "none",
    stroke: "#d1f434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 303.43,
    y1: 186.07,
    x2: 303.43,
    y2: 225.09,
    fill: "none",
    stroke: "#d1f434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.99,
    y1: 205.58,
    x2: 82.01,
    y2: 205.58,
    fill: "none",
    stroke: "#d1f434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.01,
    y1: 186.07,
    x2: 82.01,
    y2: 225.09,
    fill: "none",
    stroke: "#d1f434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.84,123.86h127.75c13.71,0,24.85,11.13,24.85,24.85v113.77c0,13.71-11.13,24.85-24.85,24.85h-127.75c-13.71,0-24.85-11.13-24.85-24.85v-113.77c0-13.71,11.13-24.85,24.85-24.85Z",
    fill: "none",
    stroke: "#f7f7f7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.14
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRivalAiIcon);
export default __webpack_public_path__ + "static/media/rival-ai-icon.6cab5e8df890b660aa9f1373e1e1b526.svg";
export { ForwardRef as ReactComponent };